import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GLOBALSETTINGS } from '../data/constants';

interface RowSelectedState {
    parentFolderId: number | null;
}

const initialState: RowSelectedState = {
    parentFolderId: GLOBALSETTINGS.DEFAULT_STATE
};

const rowSelectedSlice = createSlice({
    name: 'rowSelected',
    initialState,
    reducers: {
         setRowSelectedFolder: (state, action: PayloadAction<{parentFolderId: number | null}>) => {
            state.parentFolderId = action.payload.parentFolderId;
        },        
        clearRowSelectedFolder:(state)=>{
            state.parentFolderId =  GLOBALSETTINGS.DEFAULT_STATE;
        }
    },
});

export const { setRowSelectedFolder, clearRowSelectedFolder} = rowSelectedSlice.actions;

export default rowSelectedSlice.reducer;
